(function () {
  'use strict';
  function init() {
    document.querySelectorAll('.product-details-page').forEach(function (section) {
      if (!section.querySelector('[data-fbp-buy-summary]') || section.dataset.fbpBuySummaryReady) return;
      section.dataset.fbpBuySummaryReady = '1';
      // Re-query after every mutation: variant selection replaces the price node.
      // Mirror the existing currency/VAT/sale display rather than calculating a second price.
      function sync() {
        var source = section.querySelector('#ProductPrice');
        var price = source ? (source.textContent || '').trim() : '';
        if (!/\d/.test(price)) return;
        section.querySelectorAll('[data-fbp-buy-price]').forEach(function (target) {
          if (target.textContent.trim() !== price) target.textContent = price;
        });
      }
      sync();
      new MutationObserver(sync).observe(section, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
